export enum IPageStatus {
    LAUNCH = 'LAUNCH', // 开售
}
